import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const trendingArticles = articles.filter((a) => a.isTrending).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-fire-line text-xl text-accent-600"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门趋势
            </h2>
            <p className="text-sm text-foreground-500">当下最火的吃瓜内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {trendingArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 w-7 h-7 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">
                  {index + 1}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-chat-3-line text-xs"></i>
                    {article.commentCount > 1000 ? `${(article.commentCount / 1000).toFixed(1)}k` : article.commentCount}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line text-xs"></i>
                    {article.readTime}分钟阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}